import { ListItemButton, ListItemIcon, ListItemText, colors } from '@mui/material';
import { ReactNode } from 'react';

export type BaseSelectorProps = {
  title: string;
  description: string;
  selected: boolean;
  icon: ReactNode;
  loading: boolean;
  disabled: boolean;
  disabledReason?: string;
  onSelected: () => void;
};

// Pre-defined selectors don't need to repeat their display, but can customize it if necessary
export type SelectorProps = Omit<BaseSelectorProps, 'title' | 'icon' | 'loading' | 'disabled' | 'disabledReason'> & {
  title?: string;
  icon?: ReactNode;
  loading?: boolean;
  disabled?: boolean;
  disabledReason?: string;
};

export const BaseSelector = ({ title, description, selected, disabled, loading, disabledReason, onSelected, icon }: BaseSelectorProps) => {
  return (
    <ListItemButton
      component="button"
      data-role="export-format-selector"
      selected={selected}
      disabled={disabled || loading}
      onClick={onSelected}
      sx={{
        borderRadius: '4px',
        py: 1.5,
        mb: 2,
        backgroundColor: selected ? 'inherit' : 'white',
        border: '1px solid',
        borderColor: 'grey.300',
        '&.Mui-selected': { borderColor: colors.blue[400] },
      }}
      alignItems="flex-start"
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        primary={title}
        secondary={disabled && disabledReason ? disabledReason : description}
        primaryTypographyProps={{ component: 'span', fontWeight: '500', fontSize: '1rem', mb: 1.25 }}
        secondaryTypographyProps={{ color: 'text.secondary' }}
      />
    </ListItemButton>
  );
};
